<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="500">
            <v-card>
                <v-card-title>{{title}}</v-card-title>
                <v-card-subtitle>{{ $t('TRUCK_BRAND_SUBTITLE') }}</v-card-subtitle>
                <v-card-text>
                    <div class="text-center" v-if="loading.data">
                        <v-progress-circular
                            indeterminate
                            color="primary">
                        </v-progress-circular>
                    </div>
                    <v-form
                        ref="form"
                        v-model="valid"
                        v-else>
                        <v-text-field
                            :label="$t('TRUCK_BRANDS_NAME')"
                            v-model="form.name"
                            :rules="rules.name">
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        :disabled="!valid || loading.data || loading.submit"
                        :loading="loading.submit"
                        @click="submit">
                        {{ $t('BTN_SAVE') }}
                    </v-btn>
                    <v-btn
                        text
                        @click="close">
                        {{ $t('BTN_CANCEL') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AlertDialog from './AlertDialog';
export default {
    name: "TruckBrandDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            display: false,
            editMode: false,
            loading: {
                data: true,
                submit: false
            },
            valid: false,
            form: {
                id: null,
                name: null
            },
            rules: {
                name: [
                    v => !!v || this.$t('RULES_REQUIRED_MSG')
                ]
            }
        }
    },
    computed: {
        ...mapState("truckBrand", ["truckBrand"]),
        title() {
            if(!this.editMode) return this.$t('TRUCK_BRAND_NEW_TITLE');
            else return this.$t('TRUCK_BRAND_EDIT_TITLE');
        }
    },
    methods: {
        ...mapActions("truckBrand", ["fetchTruckBrand", "fetchTruckBrands", "storeTruckBrand", "updateTruckBrand"]),
        async open(params) {
            this.loading.data = true;
            this.editMode = params.editMode;
            this.display = true;
            if(this.editMode) {
                await this.fetchTruckBrand(params.id);
                this.form = this.truckBrand;
            }
            this.loading.data = false;
        },
        close() {
            this.display = false;
            this.loading.submit = false;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
        },
        submit() {
            this.loading.submit = true;
            if(!this.editMode) {
                this.storeTruckBrand(this.form)
                    .then(response => {
                        this.close();
                        this.$emit("record", response.record);
                        this.fetchTruckBrands();
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    });
            } else {
                this.updateTruckBrand(this.form)
                    .then(response => {
                        this.close();
                        this.fetchTruckBrands();
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    });
            }
        }
    }
}
</script>